/* eslint-disable jsx-a11y/role-supports-aria-props */

import React, { useState, useEffect } from "react"
import { useTheme }  from '~/contexts/ThemeContext'
import { usePdp } from '~/contexts/PdpContext'
import useInventoryHook from '~/utils/use-inventory'

import { IconChevRight } from '~/components/icons/chevrons'

import { aria_btn, radiobtn, radiobtn_label } from "~/styles/app.module.scss"
import { label, info_link } from "~/styles/pdp/pdp.module.scss"
import * as styles from "~/styles/pdp/hem.module.scss"



const Hem = () => {
  const { pdpInv, pdpVariant } = useTheme()
  const { product, onSelectHem, setShowHemInfo, onSwitchDelivery } = usePdp()
  const { shop_id, hem } = product
  const { whVarCheck } = useInventoryHook()

  const { display_name, start_end } = hem

  const hem_range = start_end.replaceAll(', ', ',').split(',').map( x => parseFloat(x))
  let hem_cnt = hem_range[0]
  let hems = []
  while (hem_cnt <= hem_range[1]) {
    hems.push(hem_cnt)
    hem_cnt += 0.5
  }
  const factory = hem_range[2] ? hem_range[2] : false

  const [currHem, setCurrHem] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const [open, setOpen] = useState(false)
  const [inStock, setInStock] = useState(false)

  const handleShow = (remove=false) => {
    if (remove) setCurrHem(false)
    setShowMenu(!showMenu)
    onSelectHem(false)
  }

  const handleOpen = () => {
    setOpen(!open)
  }

  const handleSelect = (item) => {
    setOpen(false)
    setCurrHem(item)
    onSelectHem(item, hem)
    onSwitchDelivery('ship')
  }

  useEffect(() => {
    if (!pdpVariant) return

    const size_whavail = whVarCheck(shop_id, pdpVariant)

    if (!size_whavail) setShowMenu(false)
    if (!size_whavail && currHem) {
      onSelectHem(false)
      setCurrHem(false)
    }
    setInStock(size_whavail)


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdpVariant, pdpInv])

  return (
    <div className={styles.hem}>

      {!showMenu ? (
        <div className={styles.hem_toggle}>
          <button 
            id="ar_label-hem"
            className={aria_btn}
            type="button"
            onClick={(e)=> {handleShow()}}
            disabled={(!pdpVariant || !inStock) ? 'disabled' : undefined}
          >
            <svg className={styles.svg_plus} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 6.66667V25.3333" stroke="#333333" strokeLinecap="square" strokeLinejoin="round"></path>
              <path d="M6.66699 16H25.3337" stroke="#333333" strokeLinecap="square" strokeLinejoin="round"></path>
            </svg>
            {(pdpVariant && !inStock) && 'Alterations unavailable in this size'}
            {!pdpVariant && 'Select a size to add alteration'}
            {(pdpVariant && inStock) && 'Add free alteration'}
          </button>
          <div className={styles.hem_more}>
            <button 
              className={[aria_btn, info_link].join(' ')}
              aria-label="Open hem guide dialog"
              type="button"
              onClick={(e)=> {setShowHemInfo(true)}} 
            >
             More Info
            </button>
          </div>
        </div>
      ) : (
        <div className={styles.hem_btns}>
          <div className={label}>
            <div>
              {display_name}
            </div>
            <div>
              <button 
                className={[aria_btn, info_link].join(' ')}
                type="button"
                onClick={(e)=> {handleShow(true)}}
              >
                Remove
              </button>
            </div>
          </div>
          <div className={styles.drop}>
            <button
              type="button" 
              className={[aria_btn, styles.drop_btn].join(' ')}
              aria-pressed={open ? 'true' : 'false'}
              onClick={(e)=> {handleOpen()}}
            >
              <span bm-drop-txt="">
                {currHem ? `${currHem}" Inseam` : 'Select Inseam'}
              </span>
              <IconChevRight icon_classes={''} />
            </button>

            <div 
              className={styles.drop_opts}
              role="menu" 
              aria-labelledby="ar_label-hem"
              aria-expanded={open ? 'true' : 'false'}
            >
               
              {hems && hems.map( (item, index) => 
                <label key={`hem${item.toString().replace('.','')}`} className={radiobtn} htmlFor={`pdp_hem_${item.toString().replace('.','')}`} >
                  <input 
                    type="radio" 
                    name={'pdp_hem'}
                    id={`pdp_hem_${item.toString().replace('.','')}`}
                    aria-labelledby={`ar_label-hem_${item.toString().replace('.','')}`}
                    defaultChecked={item === currHem ? 'checked' : undefined}
                    value={item.toString()}
                    onChange={(e)=> {handleSelect(item)}}
                  />
                  <div id={`ar_label-hem_${item.toString().replace('.','')}`} className={radiobtn_label}>
                    {item}
                  </div>
                </label>
              )}
            </div>
          </div>
          <p className={styles.hem_note}>
            {factory && (
              <>
                Factory length: {factory}".&nbsp;
              </>
            )}
            All altered items are considered final sale, no in-store pickup.
          </p>
        </div>
      )}
    </div>
  )
};

export default Hem







